import React, { useState } from "react";
import { Col, Dropdown, Form } from "react-bootstrap";
import {
  BsSearch,
  BsThreeDotsVertical,
  BsEmojiSmile,
  BsArrowReturnRight,
  BsFolder,
  BsSend,
} from "react-icons/bs";

export default function ChatRightSection() {
  const emojis = ["😀", "🥰", "😍", "🤩", "😜", "❤️", "👍", "👎", "➕"];

  const [showSearch, setShowSearch] = useState(false);
  const [message, setMessage] = useState("");
  const [activeEmojiMessage, setActiveEmojiMessage] = useState(null);

  const [messages, setMessages] = useState([
    {
      id: 1,
      type: "left",
      text: "Hi John, I wanted to update you on a new company policy.",
      time: "08:00 AM",
    },
    {
      id: 2,
      type: "right",
      text: "Sure, Sarah. What’s the new policy?",
      time: "08:00 AM",
    },
    {
      id: 3,
      type: "left",
      text: "Do you have a moment?",
      time: "08:01 AM",
    },
  ]);

  const sendMessage = (e) => {
    e.preventDefault();
    if (!message) return;

    setMessages([
      ...messages,
      {
        id: Date.now(),
        type: "right",
        text: message,
        time: new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
      },
    ]);

    setMessage("");
  };

  return (
    <Col
      xs={12}
      md={9}
      lg={8}
      className="d-flex flex-column chat-col rounded-3 border   "
    >
      <style>{`

.chat-col{
height:100vh;
padding:0;
}

.chat-header{
background:#fff;
}

.chat-body{
background:#f5f6fa;
flex:1;
overflow-y:auto;
padding:16px;
}

.message-wrapper{
display:flex;
margin-bottom:16px;
position:relative;
align-items:flex-end;
}

.message-wrapper.right{
justify-content:flex-end;
}

.message-bubble{
padding:10px 14px;
border-radius:10px;
max-width:260px;
font-size:14px;
word-break:break-word;
}

.message-left{
background:#fff;
}

.message-right{
background:#dfe6ff;
}

.message-avatar{
width:35px;
height:35px;
border-radius:50%;
margin:0 6px;
}

.message-icons{
display:flex;
align-items:center;
gap:6px;
}

.message-icon-hover{
opacity:0;
transition:0.2s;
cursor:pointer;
}

.message-wrapper:hover .message-icon-hover{
opacity:1;
}

.timestamp{
font-size:12px;
color:#777;
margin-top:4px;
}

.chat-footer{
background:#fff;
padding:10px;
border-top:1px solid #eee;
display:flex;
gap:8px;
align-items:center;
flex-wrap:wrap;
}

.chat-footer input{
flex:1;
min-width:120px;
}

.emoji-picker{
position:absolute;
bottom:45px;
background:#fff;
border-radius:8px;
padding:8px;
box-shadow:0 3px 10px rgba(0,0,0,0.1);
z-index:100;
}

/* MOBILE */

@media(max-width:768px){

.chat-body{
padding:10px;
}

.message-bubble{
max-width:200px;
font-size:13px;
}

.message-avatar{
width:30px;
height:30px;
}

.chat-footer{
gap:6px;
}

}

`}</style>

      {/* HEADER */}

      <div className="chat-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div className="d-flex align-items-center gap-2">
          <img
            src="/assets/img/profiles/avatar-29-1.jpg"
            className="message-avatar"
          />

          <div>
            <h6 className="mb-0">Anthony Lewis</h6>
            <span style={{ color: "green", fontSize: 12 }}>Online</span>
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          <BsSearch
            style={{ cursor: "pointer" }}
            onClick={() => setShowSearch(!showSearch)}
          />

          <Dropdown>
            <Dropdown.Toggle variant="light" size="sm">
              <BsThreeDotsVertical />
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
              <Dropdown.Item>Mute Notification</Dropdown.Item>
              <Dropdown.Item>Disappearing Message</Dropdown.Item>
              <Dropdown.Item>Clear Message</Dropdown.Item>
              <Dropdown.Item>Delete Chat</Dropdown.Item>
              <Dropdown.Item>Block</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* SEARCH */}

      {showSearch && (
        <div className="p-2 border-bottom">
          <Form.Control placeholder="Search Contacts" />
        </div>
      )}

      {/* MESSAGES */}

      <div className="chat-body">
        {messages.map((msg) => {
          const isRight = msg.type === "right";

          return (
            <div
              key={msg.id}
              className={`message-wrapper ${isRight ? "right" : ""}`}
            >
              {/* LEFT MESSAGE */}

              {!isRight && (
                <img
                  src="/assets/img/profiles/avatar-29-1.jpg"
                  className="message-avatar"
                />
              )}

              {/* SENDER ICONS LEFT SIDE */}

              {isRight && (
                <div className="message-icons mb-3">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      size="sm"
                      style={{ background: "transparent", border: "none" }}
                    >
                      <BsThreeDotsVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item>Reply</Dropdown.Item>
                      <Dropdown.Item>Forward</Dropdown.Item>
                      <Dropdown.Item>Copy</Dropdown.Item>
                      <Dropdown.Item>Delete</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <BsEmojiSmile
                    className="message-icon-hover"
                    onClick={() =>
                      setActiveEmojiMessage(
                        activeEmojiMessage === msg.id ? null : msg.id,
                      )
                    }
                  />

                  <BsArrowReturnRight className="message-icon-hover" />
                </div>
              )}

              <div>
                <div
                  className={`message-bubble ${isRight ? "message-right" : "message-left"}`}
                >
                  {msg.text}
                </div>

                <div className="timestamp">
                  {isRight
                    ? `${msg.time} • You`
                    : `Anthony Lewis • ${msg.time}`}
                </div>
              </div>

              {/* RECEIVER ICONS RIGHT SIDE */}

              {!isRight && (
                <div className="message-icons mb-3">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      size="sm"
                      style={{ background: "transparent", border: "none" }}
                    >
                      <BsThreeDotsVertical />
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item>Reply</Dropdown.Item>
                      <Dropdown.Item>Forward</Dropdown.Item>
                      <Dropdown.Item>Copy</Dropdown.Item>
                      <Dropdown.Item>Delete</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <BsEmojiSmile
                    className="message-icon-hover"
                    onClick={() =>
                      setActiveEmojiMessage(
                        activeEmojiMessage === msg.id ? null : msg.id,
                      )
                    }
                  />

                  <BsArrowReturnRight className="message-icon-hover" />
                </div>
              )}

              {isRight && (
                <img
                  src="/assets/img/profiles/avatar-14-1.jpg"
                  className="message-avatar"
                />
              )}

              {/* EMOJI PICKER */}

              {activeEmojiMessage === msg.id && (
                <div
                  className="emoji-picker"
                  style={{
                    right: isRight ? "60px" : "auto",
                    left: !isRight ? "60px" : "auto",
                  }}
                >
                  {emojis.map((e, i) => (
                    <span
                      key={i}
                      style={{
                        fontSize: 20,
                        cursor: "pointer",
                        marginRight: 6,
                      }}
                      onClick={() => {
                        setMessage(message + e);
                        setActiveEmojiMessage(null);
                      }}
                    >
                      {e}
                    </span>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* FOOTER */}

      <form onSubmit={sendMessage} className="chat-footer">
        <Form.Control
          placeholder="Type Your Message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <div style={{ position: "relative" }}>

<BsEmojiSmile
  style={{ cursor: "pointer", fontSize:"18px" }}
  onClick={() =>
    setActiveEmojiMessage(
      activeEmojiMessage === "input" ? null : "input"
    )
  }
/>

{activeEmojiMessage === "input" && (

<div
  className="emoji-picker"
  style={{
    position:"absolute",
    bottom:"40px",
    right:"0",
    background:"#fff",
    padding:"8px",
    borderRadius:"8px",
    boxShadow:"0 3px 10px rgba(0,0,0,0.1)"
  }}
>

{emojis.map((e,i)=>(
<span
key={i}
style={{fontSize:20,cursor:"pointer",marginRight:6}}
onClick={()=>{
setMessage(message + e);
setActiveEmojiMessage(null);
}}
>
{e}
</span>
))}

</div>

)}

</div>

        <label style={{ cursor: "pointer" }}>
          <BsFolder />

          <input type="file" hidden />
        </label>

        <Dropdown>
          <Dropdown.Toggle variant="light" size="sm">
            <BsThreeDotsVertical />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item>Camera</Dropdown.Item>
            <Dropdown.Item>Gallery</Dropdown.Item>
            <Dropdown.Item>Audio</Dropdown.Item>
            <Dropdown.Item>Location</Dropdown.Item>
            <Dropdown.Item>Contact</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <button style={{backgroundColor:"#FF5722"}} className="btn  btn-sm">
          <BsSend style={{color:"whitesmoke"}} className="text-white" />
        </button>
      </form>
    </Col>
  );
}
